<template>
  <div>
    <a-modal :visible="modalVisible" :closable="false" :width="width" @cancel="closeModal">
      <a-table
        :scroll="{ x: width }"
        :columns="columns"
        :pagination="{
          ...pagination
        }"
        size="middle"
        :data-source="ticketList"
        :loading="loading"
        row-key="id"
        @change="handleTableChange"
      >
        <!-- 自定义列 -->
        <span slot="customKey" slot-scope="text, record">
          <div v-if="record.type === 1 && record.isOverTime >= 6 && [0, 2].includes(record.status)" class="corner-bad" />
          <div v-if="record.type === 1 && record.isOverTime >= 4 && record.isOverTime < 6 && [0, 2].includes(record.status)" class="corner-middle" />
          <div v-if="record.type === 1 && record.isOverTime > 2 && record.isOverTime < 4 && [0, 2].includes(record.status)" class="corner" />
          <span>{{ record.id }}</span>
        </span>

        <span slot="name" slot-scope="text, record">
          <a @click="toDetail(record.id)">{{ record.name }}</a>
        </span>

        <span slot="status" slot-scope="text, record">
          <a-tag :color="ticketStatus[record.status].color">{{ ticketStatus[record.status].label }}</a-tag>
        </span>

        <template slot="domain" slot-scope="text, record">
          <span v-if="ticketDomain[record.domain]">
            <a-tag :color="ticketDomain[record.domain].color">{{ ticketDomain[record.domain].label }}</a-tag>
          </span>
          <span v-else>-</span>
        </template>

        <span slot="tags" slot-scope="text, record">
          <a-tag>{{ getTagTitle(record.tags) }}</a-tag>
        </span>

        <span slot="isOverTime" slot-scope="text, record">
          {{ record.isOverTime + '小时' }}
        </span>

        <span slot="handler" slot-scope="text, record">
          {{ getUserById(record.handler) }}
        </span>

        <span slot="maintainer" slot-scope="text, record">
          {{ getUserListById(record.maintainer) }}
        </span>

        <span slot="creator" slot-scope="text, record"> 客服{{ record.creator }} </span>

        <span slot="meta" slot-scope="text, record">
          <a class="custom-link" target="_blank" @click="toDetail(record.id)">{{ record.meta.desc }}</a>
        </span>

        <template slot="attach" slot-scope="text, record">
          <span v-if="record.meta.image.length > 0">
            <a-upload action="https://www.mocky.io/v2/5cc8019d300000980a055e76" list-type="picture-card" :file-list="convertImageList(record.meta.image)" @preview="handlePreview" />
          </span>
          <span v-else>无附件</span>
        </template>

        <template slot="reply" slot-scope="text, record">
          <span v-if="record.reply[0]?.desc">
            <a class="custom-link">{{ record.reply[0].desc.replace(/!$$.*?$$$https:\/\/devops\-resource\.cdfsunrise\.com\/other\/\w+\.png$/g, '') }}</a>
          </span>
          <span v-else>--</span>
        </template>

        <span slot="reporter" slot-scope="text, record">
          <problem-user-edit :source-id="record.id" :source-value="record.reporter" item="reporter" />
        </span>
      </a-table>

      <!-- 图片预览模态框 -->
      <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
        <img alt="example" style="width: 100%" :src="previewImage" />
      </a-modal>

      <!-- 底部空内容 -->
      <div slot="footer" />
    </a-modal>

    <!-- 抽屉详情 -->
    <ticket-drawer v-if="editVisible" :visible="editVisible" :ticket-id="ticketId" @close="close" />
  </div>
</template>

<script>
import { problemUrgencys, problemStatus, ticketStatus, problemChannels, ticketDomain, ticketLevel, ticektTag, qiyuTicketStatus } from '@/utils/dictionary';
import TicketDrawer from '@/pages/event/components/TicketDrawer';
import { queryTickets } from '@/api/event/problem';
import { taskStatus, ticketColumns } from '@/utils/dictionary';

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

export default {
  name: 'TicketListModal',
  components: {
    TicketDrawer
  },
  props: {
    taskList: {
      type: Array,
      default: null
    },
    targetColumns: {
      type: Array,
      default: null
    },
    userList: {
      type: Array,
      default: null
    },
    tagList: {
      type: Array,
      default: null
    },
    width: {
      type: Number,
      default: 1800
    }
  },
  data() {
    return {
      editVisible: false,
      modalVisible: false,
      ticketId: 0,
      columns: [],
      ticketList: [],
      loading: false,
      previewVisible: false,
      previewImage: '',
      taskStatus,
      filterForm: {
        pageSize: 20,
        pageNumber: 1
      },
      pagination: {
        size: 'large',
        total: 0,
        pageSize: 20,
        current: 1,
        showTotal: total => `共 ${total} 条`
      },
      ticketStatus,
      problemChannels,
      problemUrgencys,
      qiyuTicketStatus,
      ticketDomain,
      ticketLevel,
      ticketColumns
    };
  },
  computed: {
    link() {
      return record => {
        return record && record.project && record.taskId ? this.$router.resolve({ name: 'page:project:task:detail', query: { taskId: record.taskId }, params: { project_id: record.project }}).href : '';
      };
    }
  },
  mounted() {
    if (this.targetColumns != null) {
      this.columns = this.targetColumns;
    } else {
      this.columns = this.ticketColumns;
    }
  },
  methods: {
    getTodoList() {
      this.modalVisible = true;
    },
    convertImageList(imageList) {
      return imageList.map((url, index) => ({
        uid: `-${index + 1}`,
        name: 'image.png',
        status: 'done',
        url: url
      }));
    },
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
    closeModal() {
      this.modalVisible = false;
    },
    handleCancel() {
      this.previewVisible = false;
    },
    close() {
      this.editVisible = false;
    },
    toDetail(ticketId) {
      this.ticketId = ticketId;
      this.editVisible = true;
    },
    open() {
      this.$nextTick(() => {
        this.ticketList = [];
        this.filterForm.ids = this.taskList;
        this.filterForm.pageNumber = 1;
        this.filterForm.pageSize = 20;
        this.loading = true;

        // 更新分页器状态
        this.pagination = {
          ...this.pagination,
          current: 1,
          pageSize: 20,
          total: 0
        };

        this.getTicketList();
        this.modalVisible = true;
      });
    },
    handleTableChange(pagination) {
      this.filterForm.pageNumber = pagination.current;
      this.filterForm.pageSize = pagination.pageSize;
      this.getTicketList();
    },
    getTicketList() {
      this.loading = true;
      if (typeof this.taskList[0] === 'number') {
        queryTickets(this.filterForm)
          .then(res => {
            this.ticketList = res.data?.ticketList || [];
            this.pagination = {
              ...this.pagination,
              total: res.data?.total || 0
            };
          })
          .catch(() => {
            this.ticketList = [];
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.ticketList = this.taskList || [];
        this.loading = false;
      }
    },
    getTagTitle(key) {
      const node = this.findNodeByKey(this.tagList, key);
      return node ? node.title : '';
    },
    findNodeByKey(tree, key) {
      for (const node of tree) {
        if (node.key == key) {
          return node;
        }
        if (node.children) {
          const foundNode = this.findNodeByKey(node.children, key);
          if (foundNode) return foundNode;
        }
      }
      return null;
    },
    getUserById(user_id) {
      const user = this.userList?.find(item => item.fs_user_id === user_id);
      return user ? user.nickname : '-';
    },
    onViewFault(record) {
      return this.$router.resolve({ name: 'page:event:ticket:detail', query: { ticketId: record.id }}).href;
    },
    getUserListById(user_id_list) {
      if (!user_id_list) return '--';
      let ids = user_id_list;
      if (!Array.isArray(user_id_list)) {
        try {
          ids = JSON.parse(user_id_list);
        } catch {
          return '--';
        }
      }

      const names = ids
        .map(userId => {
          const user = this.userList?.find(item => item.fs_user_id === userId);
          return user ? user.nickname : null;
        })
        .filter(Boolean);

      return names.length ? names.join('; ') : '--';
    }
  }
};
</script>

<style scoped>
.purple {
  background-color: rgba(128, 50, 150, 0.5);
  color: white;
  border-radius: 6px;
}

.orange {
  background-color: orange;
  color: white;
  border-radius: 6px;
}

.purple-orange {
  background: linear-gradient(to right, rgba(128, 50, 150, 0.5) 50%, orange 50%);
  color: white;
  border-radius: 6px;
}
</style>
